
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { get_name_initials } from "@/utils/global";
import { get_job_by_id } from "@/store/apis/common";
import { jobLabelForAiInterviewInvite } from "@/utils/ai_interview_invite_job_label";
import {
  PERSON_INTERVIEW_INVITES,
  INIT_AI_INTERVIEW_INVITES
} from "@/store/modules/recruiter_ai_interviews/constants";

export default Vue.extend({
  name: "RecruiterPersonInterviewAgentListing",
  data() {
    return {
      jobTitleById: {} as Record<string, string>
    };
  },
  computed: {
    ...mapGetters("recruiter_ai_interviews", {
      invites: PERSON_INTERVIEW_INVITES
    })
  },
  async created() {
    await this.initInvites();
    await this.hydrateJobTitles();
  },
  watch: {
    invites: {
      deep: true,
      async handler() {
        await this.hydrateJobTitles();
      }
    }
  },
  methods: {
    ...mapActions("recruiter_ai_interviews", {
      initInvites: INIT_AI_INTERVIEW_INVITES
    }),
    displayJobLabel(invite: Record<string, unknown>) {
      return jobLabelForAiInterviewInvite(invite, this.jobTitleById);
    },
    async hydrateJobTitles() {
      const list = Array.isArray(this.invites) ? this.invites : [];
      for (const invite of list) {
        const jobId = Number((invite as { job_id?: number }).job_id || 0);
        if (!jobId) continue;
        const key = String(jobId);
        if (this.jobTitleById[key]) continue;
        try {
          const resp = await get_job_by_id(jobId);
          const payload = (resp as any)?.data?.data || (resp as any)?.data || {};
          const title = String(payload?.job_title || payload?.title || "").trim();
          if (title && !/^job\s*#\s*\d+$/i.test(title)) {
            this.$set(this.jobTitleById, key, title);
          } else {
            this.$set(this.jobTitleById, key, "");
          }
        } catch (_e) {
          this.$set(this.jobTitleById, key, "");
        }
      }
    },
    getInitials(name: string) {
      return get_name_initials(name || "Candidate");
    },
    formatDate(iso: string) {
      try {
        const d = new Date(iso);
        return d.toLocaleString();
      } catch (e) {
        return iso;
      }
    },
    normalizeName(name: string) {
      const cleaned = String(name || "").replace(/\s+/g, " ").trim();
      if (!cleaned) return "Candidate";
      const parts = cleaned.split(" ");
      const collapsed = parts.filter((p, i) => i === 0 || p.toLowerCase() !== parts[i - 1].toLowerCase());
      const half = Math.floor(collapsed.length / 2);
      if (
        collapsed.length % 2 === 0 &&
        half > 0 &&
        collapsed.slice(0, half).join(" ").toLowerCase() ===
          collapsed.slice(half).join(" ").toLowerCase()
      ) {
        return collapsed.slice(0, half).join(" ");
      }
      return collapsed.join(" ");
    },
    openInvite(inviteId: string) {
      this.$router.push({
        name: "recruiter-person-interview-details",
        query: { inviteId }
      });
    }
  }
});
